import { render, staticRenderFns } from "./WheelsAddressPicker.vue?vue&type=template&id=55151ab3&scoped=true"
import script from "./WheelsAddressPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsAddressPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsAddressPicker.vue?vue&type=style&index=0&id=55151ab3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55151ab3",
  null
  
)

export default component.exports